import React  from "react";

// Common Component ------//

export const CUSTOMROUTES = React.lazy(() =>
  import("../../Routes/CustomRoutes")
);
